// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__8D9Be","label":"Labeled_label__27m9P","divider":"Labeled_divider__1K7zp"};